import React from "react";
import CalendarComponent from "../Components/CalendarComponent";
import LoadingSpinner from "../Components/LoadingSpinner";

// ✅ Import from Liveblocks React
import { RoomProvider, ClientSideSuspense } from "@liveblocks/react";

function Calendar() {
  console.log(
    "📅 Calendar component rendering, setting up RoomProvider for room: motion-air-calendar"
  );

  // Always mount RoomProvider so Liveblocks hooks have context

  return (
    <RoomProvider id="motion-air-calendar" initialPresence={{ cursor: null }}>
      <ClientSideSuspense fallback={<LoadingSpinner />}>
        <CalendarComponent />
      </ClientSideSuspense>
    </RoomProvider>
  );
}

export default Calendar;
